import Axios from 'axios'

const isValidateFeatureFlag = async (tag, client) => {
  const data = {
    tag,
    client
  }
  const { data: isValid } = await Axios.post(`${process.env.VUE_APP_API_URL}/feature-flags/validate`, data)

  return isValid
}

export default isValidateFeatureFlag
